







































































































import { Vue, Component } from "vue-property-decorator"
import SInfoBox from "@/components/SInfoBox"
import SStatusBox from "@/components/SStatusBox"
import SCustomerShop from "@/components/SCustomerShop"
import SShopForm from "@/components/SShopForm"
import { Venue, Market } from "@/models"
import { VenueModule, MarketModule } from "@/consts"
import {
    GET_VENUE_LIST,
    HAS_SELECTED_MARKET,
    GET_SELECTED_MARKET,
    GET_SELECTED_MARKET_TOTAL_VENUE,
    GET_SELECTED_MARKET_TOTAL_BOX,
    GET_SELECTED_MARKET_TOTAL_ONLINE_BOX,
    GET_SELECTED_MARKET_TOTAL_OFFLINE_BOX,
    GET_SELECTED_MARKET_TOTAL_UPDATE_REQUIRED_BOX,
    GET_VENUE_TOTAL_BOX_FN,
    GET_VENUE_TOTAL_ONLINE_BOX_FN,
    GET_VENUE_TOTAL_OFFLINE_BOX_FN,
    GET_VENUE_TOTAL_UPDATE_REQUIRED_BOX_FN,
} from "@/store/types/getters"
import SCustomerSearchForm from "@/components/SCustomerSearchForm"
import { UPDATE_SELECTED_VENUE } from "@/store/types/mutations"
import { fetchVenueList } from "@/store/types/actions"
import { Getter } from "vuex-class"

@Component({
    components: {
        SInfoBox,
        SStatusBox,
        SCustomerShop,
        SCustomerSearchForm,
        SShopForm,
    },
})
export default class CustomerDashboard extends Vue {
    @Getter(GET_VENUE_TOTAL_BOX_FN)
    private venueTotalBoxFn!: (marketId: string, venueId: string) => number

    @Getter(GET_VENUE_TOTAL_ONLINE_BOX_FN)
    private venueTotalOnlineBoxFn!: (
        marketId: string,
        venueId: string
    ) => number

    @Getter(GET_VENUE_TOTAL_OFFLINE_BOX_FN)
    private venueTotalOfflineBoxFn!: (
        marketId: string,
        venueId: string
    ) => number

    @Getter(GET_VENUE_TOTAL_UPDATE_REQUIRED_BOX_FN)
    private venueTotalUpdateRequiredBoxFn!: (
        marketId: string,
        venueId: string
    ) => number

    @MarketModule.Getter(HAS_SELECTED_MARKET)
    private hasSelectedMarket!: boolean
    @MarketModule.Getter(GET_SELECTED_MARKET)
    private selectedMarket!: Market | null
    @MarketModule.Getter(GET_SELECTED_MARKET_TOTAL_VENUE)
    private selectedMarketTotalVenue!: number
    @MarketModule.Getter(GET_SELECTED_MARKET_TOTAL_BOX)
    private selectedMarketTotalBox!: number
    @MarketModule.Getter(GET_SELECTED_MARKET_TOTAL_ONLINE_BOX)
    private selectedMarketTotalOnlineBox!: number
    @MarketModule.Getter(GET_SELECTED_MARKET_TOTAL_OFFLINE_BOX)
    private selectedMarketTotalOfflineBox!: number
    @MarketModule.Getter(GET_SELECTED_MARKET_TOTAL_UPDATE_REQUIRED_BOX)
    private selectedMarketTotalUpdateRequiredBox!: number

    @VenueModule.Mutation(UPDATE_SELECTED_VENUE) updateSelectedVenue!: (
        payload: Venue
    ) => void
    @VenueModule.Getter(GET_VENUE_LIST) venueList!: Venue[]
    @VenueModule.Action(fetchVenueList) fetchVenueList!: () => void

    private onBack() {
        this.$router.push("/customers")
    }

    private onSearch() {
        const options = {
            name: "SCustomerSearchForm",
            height: "auto",
            draggable: true,
        }

        this.$modal.show(SCustomerSearchForm, undefined, options)
    }

    private onClickShop(payload: Venue) {
        this.updateSelectedVenue(payload)
        this.$router.push({
            path: `/customers/${payload.id}/shops`,
            hash: payload.id,
        })
    }

    private onAdd() {
        const options = {
            name: "SShopForm",
            height: "auto",
            draggable: false,
        }

        this.$modal.show(SShopForm, undefined, options)
    }

    public mounted() {
        this.fetchVenueList()
    }

    public activated() {
        this.fetchVenueList()
    }
}
